import {
  Box,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Button,
  HStack,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { arrayToOption } from "../../Utils/formatUtils";
import { createSkeleton } from "../../Utils/utils";
import CustomTBody from "../Common/Table/CustomTBody";
import TdType from "../Common/Table/TdType";
import Select from "react-select";

const customStyles = {
  menu: (provided) => ({
    ...provided,
    fontSize: "0.8rem",
  }),
};

export const OperatorsTable = ({
  isLoading,
  operatorsActions,
  actionList,
  handleSavePermission,
  isSubmitting,
}) => {
  const history = useHistory();
  const [newOperatorsActions, setNewOperatorsActions] = useState([]);

  useEffect(() => {
    setNewOperatorsActions(operatorsActions);
  }, [operatorsActions]);

  const actionListOptions = actionList.map((group) => {
    const options = arrayToOption(
      group.actions,
      "actionId",
      "actionName",
      null
    );
    return {
      ...group,
      options: options,
    };
  });

  const handleSelect = (newPermission) => {
    let changedOperatorsActions = [...newOperatorsActions];

    const indexOperator = changedOperatorsActions.findIndex(
      (operator) => operator.user.id === newPermission.operator
    );

    const indexAction = changedOperatorsActions[
      indexOperator
    ].actions.findIndex((action) => action.groupId === newPermission.groupId);

    changedOperatorsActions[indexOperator].actions[indexAction].actionId =
      newPermission.value;
    changedOperatorsActions[indexOperator].actions[indexAction].actionName =
      newPermission.label;

    setNewOperatorsActions(changedOperatorsActions);
  };

  const createRows = () => {
    let formattedRows = newOperatorsActions.map((operator) => {
      const actionMap = actionListOptions.map((actGroup) => {
        const currentGroup = operator.actions.find(
          (opGroup) => opGroup.groupId === actGroup.group.groupId
        );
        return {
          item: (
            <Select
              options={actGroup.options.map((option) => {
                return {
                  ...option,
                  operator: operator.user.id,
                  groupId: currentGroup.groupId,
                };
              })}
              value={{
                label: currentGroup.actionName,
                value: currentGroup.actionId,
                operator: operator.user.id,
                groupId: currentGroup.groupId,
              }}
              styles={customStyles}
              menuPortalTarget={document.body}
              onChange={(e) => handleSelect(e)}
            />
          ),
        };
      });

      return [
        {
          item: (
            <TdType
              text={`${operator.user.firstName} ${operator.user.lastName}`}
            />
          ),
        },
        ...actionMap,
      ];
    });
    return formattedRows;
  };

  return (
    <>
      <Box overflowX={"scroll"} pb={"0.5rem"}>
        <Table variant="striped" colorScheme="gray" fontSize="0.8em">
          {isLoading ? (
            <CustomTBody rows={[createSkeleton(4)]} />
          ) : (
            <>
              <Thead>
                <Tr>
                  <Th fontSize="0.8em" w={"15%"}>
                    Operador
                  </Th>
                  {actionList.map((action) => (
                    <Th
                      fontSize="0.8em"
                      w={"10%"}
                      textAlign={"center"}
                      key={action.group.groupId}
                    >
                      {action.group.groupName}
                    </Th>
                  ))}
                </Tr>
              </Thead>
              {newOperatorsActions.length ? (
                <CustomTBody rows={createRows()} />
              ) : (
                <Tbody>
                  <Tr>
                    <Td colSpan="100%">
                      <Box padding="1rem 0">No se encontraron resultados</Box>
                    </Td>
                  </Tr>
                </Tbody>
              )}
            </>
          )}
        </Table>
      </Box>
      <HStack
        justify={["center", "flex-end"]}
        mt="2rem"
        wrap={"wrap"}
        gap="0.5rem"
      >
        <Button variant="ghost" onClick={() => history.goBack()}>
          Cancelar
        </Button>
        <Button
          colorScheme="blue"
          isLoading={isSubmitting}
          onClick={() => {
            handleSavePermission(newOperatorsActions);
          }}
        >
          Guardar
        </Button>
      </HStack>
    </>
  );
};
